import { TechnicalIssuesOptionValue } from 'modules/unsubscribe/pages/TechnicalIssues/constants'

import { AppName } from 'root-constants'

export const FLOW_TECHNICAL_ISSUES_VALUES: Partial<
  Record<AppName, TechnicalIssuesOptionValue[]>
> = {
  [AppName.FEMI]: [
    TechnicalIssuesOptionValue.INCOMPATIBLE_DEVICE,
    TechnicalIssuesOptionValue.SHOP_LINKS_DONT_WORK,
    TechnicalIssuesOptionValue.PROGRESS_NOT_SAVED,
    TechnicalIssuesOptionValue.DONT_UNDERSTAND_LANGUAGE,
    TechnicalIssuesOptionValue.OTHER,
  ],
  [AppName.LUVLY]: [
    TechnicalIssuesOptionValue.INCOMPATIBLE_DEVICE,
    TechnicalIssuesOptionValue.PROGRESS_NOT_SAVED,
    TechnicalIssuesOptionValue.COULDNT_USE_PREMIUM_CONTENT,
    TechnicalIssuesOptionValue.DONT_UNDERSTAND_LANGUAGE,
    TechnicalIssuesOptionValue.OTHER,
  ],
}
